<template>
  <div class="flex flex-col gap-4" :class="errorShow ? 'error' : ''">
    <div class="flex gap-[10px]">
      <label
        class="checkbox-wrapp relative block"
        :class="textInLabel ? 'flex items-center gap-[10px]' : 'block'"
      >
        <!-- Fake checkbox wrapper -->
        <span class="block relative w-5 h-5 cursor-pointer">
          <input
            type="checkbox"
            class="absolute inset-0 opacity-0 peer"
            :checked="checked"
            :name="name"
            :required="required"
            @input="inputChange"
            :value="value"
          />
          <!-- Border -->
          <span
            class="checkbox-border absolute inset-0 block border rounded-[3px] shadow-transparent duration-200"
            :class="
              theme === 'white'
                ? 'border-white peer-focus-visible:border-white/50'
                : 'border-blue peer-focus-visible:border-blue/50'
            "
          >
          </span>

          <!-- Check -->
          <span
            class="checkbox-checked absolute inset-0 flex items-center justify-center opacity-0 duration-200 peer-checked:opacity-100"
            :class="
              theme === 'white' ? 'bg-white text-blue' : 'bg-blue text-white'
            "
          >
            <svg class="w-3 h-2 stroke-2">
              <use xlink:href="#icon-check"></use>
            </svg>
          </span>
        </span>

        <span
          class="block select-none cursor-pointer text-sm"
          v-if="textInLabel"
        >
          <slot></slot>
        </span>
      </label>

      <slot v-if="!textInLabel"></slot>
    </div>

    <p v-if="errorShow" class="text-xs text-red">{{ errorText }}</p>
  </div>
</template>

<script>
export default {
  name: 'inputCheckbox',
  props: {
    name: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    errorShow: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'This field is required',
    },
    theme: {
      type: String,
      default: 'blue',
    },
    textInLabel: {
      type: Boolean,
      default: false,
    },
    checked: Boolean,
    value: String
  },

  methods: {
    inputChange(e) {
      this.$emit('input', e.target.checked)
    },
  },
}
</script>
